'use strict';
module.exports = function(app) {
    require('./js/dashBoard.controller.js')(app);
    require('./js/dd_text_collapse.directive.js')(app);
    require('./js/view_port_helper.directive.js')(app);
    require('./js/bid_audio.directive.js')(app);
    require('./js/add_space_to_number.filter.js')(app);
    require('./js/truncate_text.filter.js')(app);
    require('./scss/dashboard-responsive.scss');
};



/*****************
 ** WEBPACK FOOTER
 ** ./dash_board/index.js
 ** module id = 31
 ** module chunks = 0
 **/